import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@services/baseQuery';
import { handleError } from '../../utils/api-error-handling';

export const netLockApi = createApi({
  reducerPath: 'netLockApi',
  baseQuery: baseQuery,
  tagTypes: ['Netlock'],
  endpoints: (builder) => ({
    deleteNetLock: builder.mutation({
      query: (payload) => ({
        url: `netlock/${payload}`,
        method: 'DELETE',
      }),
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
    }),
  }),
});

export const { useDeleteNetLockMutation } = netLockApi;
